export default __webpack_public_path__ + "static/media/eventDashboard_sump.e1ce012b.svg";